// extracted by css-extract-rspack-plugin
export default {"inner":"K4WkaGYUYYgl0Dtw"};